
import SectionHeading from '../SectionHeading.jsx';
import ClipboardText from '../icons/ClipboardText.jsx';
import { ChevronRightIcon, PlusIcon } from '@heroicons/react/24/outline';
import { formatDateTime } from '../../lib/DateTime.js';
import CustomTags from '~/components/customfields/CustomTags.jsx';
import { ObjectTypes } from '~/lib/ObjectTypes.js';

const SubmissionSummary = ({ submission, isFirst, onClick }) => {
  return (
    <div
      className={`group cursor-pointer flex justify-between items-center ${isFirst ? '' : 'border-t'} pr-4 py-4`}
      onClick={() => onClick(submission)}
    >
      <div className="flex-1">
        <div className="text-lg group-hover:underline">
          {submission.form?.name}
        </div>
        <div className="text-sm text-gray-500">
          {formatDateTime(submission.submission.created_at)}
        </div>
        <CustomTags
          type={ObjectTypes.FORM_SUBMISSION}
          id={submission.submission.id}
          fields={submission.submission.custom_fields}
        />
      </div>
      <div className="ml-2">
        <ChevronRightIcon className="w-5 h-5 text-gray-500" />
      </div>
    </div>
  );
};

const ClientFormSubmissionsList = ({ submissions, className, onClick, onAddForm }) => {
  return (
    <div className={className}>
      <SectionHeading
        icon={<ClipboardText />}
        name="Forms"
        action={!!onAddForm && (
          <button
            type="button"
            className="btn-inverse-pill-sm"
            onClick={onAddForm}
          >
            Add
          </button>
        )}
      />
      <div className="panel mt-3 pl-4">
        {submissions.map((submission, idx) => (
          <SubmissionSummary
            key={submission.submission.id}
            submission={submission}
            isFirst={idx === 0}
            onClick={onClick}
          />
        ))}
        {submissions.length === 0 && (
          <div className="text-gray-500 py-4">There are no form submissions</div>
        )}
      </div>
    </div>
  );
};

export default ClientFormSubmissionsList;
